import { useSelector } from 'react-redux';

export const useAdministrator = () => useSelector((state) => {
  const admin = state.session.user.administrator;
  return admin;
});

export const useRecovery = () => useSelector((state) => {
  const rec = state.session.user.recovery;
  return rec;
});

export const useDeviceAdd = () => useSelector((state) => {
  const admin = state.session.user.administrator;
  const manager = (state.session.user.deviceLimit || 0) !== 0;
  return admin || manager;
});

export const useManageUser = () => useSelector((state) => {
  const admin = state.session.user.administrator;
  const manager = (state.session.user.userLimit || 0) !== 0;
  return admin || manager;
});

export const useManageRecovery = () => useSelector((state) => {
  const admin = state.session.user.administrator;
  const manager = (state.session.user.recoveryLimit || 0) !== 0;
  return admin || manager;
});

export const useRestriction = (key) => useSelector((state) => {
  const admin = state.session.user.administrator;
  const serverValue = state.session.server[key];
  const userValue = state.session.user[key];
  return !admin && (serverValue || userValue);
});

export const useDeviceEdit = () => useSelector((state) => {
  const { administrator: admin } = state.session.user;
  const { deviceEdit } = state.session.user;
  return admin || deviceEdit;
});

export const useDeviceManage = () => useSelector((state) => {
  const { administrator: admin } = state.session.user;
  const { deviceManage } = state.session.user;
  return admin || deviceManage;
});

export const useCommandSend = () => useSelector((state) => {
  const { administrator: admin } = state.session.user;
  const { commandSend } = state.session.user;
  return admin || commandSend;
});

export const useAlertsManage = () => useSelector((state) => {
  const { administrator: admin } = state.session.user;
  const { alertsManage } = state.session.user;
  return admin || alertsManage;
});

export const useReportGenerate = () => useSelector((state) => {
  const { administrator: admin } = state.session.user;
  const { reportGenerate } = state.session.user;
  return admin || reportGenerate;
});

export const useRecoveryAssign = () => useSelector((state) => {
  const { administrator: admin } = state.session.user;
  const { recoveryAssign } = state.session.user;
  return admin || recoveryAssign;
});

export const useProfileEdit = () => useSelector((state) => {
  const { administrator: admin } = state.session.user;
  const { profileEdit } = state.session.user;
  return admin || profileEdit;
});
